import * as React from 'react';

// Used to break a boostrap's Row on smaller screens (<lg)
export default function ResponsiveRowBreak() {
  return <div className="w-100 d-lg-none" />;
}
